export default [
  {
    path: "/teams",
    component: () =>
      import(/* webpackChunkName: "teams" */ "@/views/teams/Teams"),
    children: [
      {
        path: "",
        name: "teams",
        meta: {
          layout: "LayoutSidebar"
        },
        component: () =>
          import(
            /* webpackChunkName: "teams" */ "@/views/teams/TeamsCategories"
          )
      },
      {
        path: ":slug",
        name: "teams-category",
        component: () =>
          import(
            /* webpackChunkName: "teams-category" */ "@/views/teams/TeamsCategory"
          )
      }
    ]
  }
];
